var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',_vm._b({style:(_vm.style),attrs:{"src":_vm.source}},'img',_vm.$attrs,false))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/poi/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7123b32c","hasScoped":false,"transformToRequire":{"img":"src","image":"xlink:href","cimage":"placeholder","c-image":"placeholder","CImage":"placeholder"},"buble":{"transforms":{}}}!./node_modules/poi/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CComponents/CImageLogo.vue
// module id = 2108
// module chunks = 1612